export default __webpack_public_path__ + "static/media/opened-bg.43018418.svg";